import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'

/**
 * Parsa una stringa ISO date-only (YYYY-MM-DD) come data locale.
 *
 * Problema: dayjs(str) delega a new Date(str); per stringhe ISO date-only
 * la spec ECMA-262 impone il parsing come UTC midnight.
 * In fusi UTC+ (es. UTC+2) UTC midnight = giorno prima alle 22:00 locale;
 * un successivo .format('YYYY-MM-DD') salva quindi il giorno sbagliato.
 *
 * Soluzione: aggiungere 'T00:00:00' trasforma la stringa in un datetime locale.
 * Specifica ISO 8601 §4.3.2: datetime senza designatore TZ = local time.
 * Non richiede il plugin customParseFormat.
 *
 * @param str  Stringa YYYY-MM-DD proveniente da API o DB.
 * @returns    Oggetto Dayjs in local time, o undefined se l'input è assente.
 */
export function parseDataPura(str: string | null | undefined): Dayjs | undefined {
  if (!str) return undefined
  return dayjs(str + 'T00:00:00')
}
